import React, { useEffect } from 'react';
import './Splashscreen.css';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/designSystem/logo/logo-white2.svg';

export default function Splashscreen() {
  const navigate = useNavigate();
  function handleRedirect() {
    navigate('/welcome');
  }

  useEffect(() => {
    setTimeout(() => {
      handleRedirect();
    }, 2000);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('source') === 'play-store-access') {
      localStorage.setItem('source', 'play store access');
    } else {
      localStorage.setItem('source', 'web access');
    }
  }, []);

  return (
    <div className="container splash">
      <div className="splash__svgs">
        <img height={40} src={logo} alt="kito logo" />
      </div>
    </div>
  );
}
